
import Vue from 'vue';
import { TeamMember } from '@run-diffusion/shared';
import { mapGetters } from 'vuex';
import ClipboardCopy from '@/components/ClipboardCopy.vue';

export default Vue.extend({
	name: 'TeamMemberJoinedStatus',
	props: {
		teamMember: { type: Object, default: null },
		team: { type: Object, default: null },
	},
	computed: {
		...mapGetters([
			'displayLabels',
		]),
	},
	methods: {
		buildTeamInviteLink(teamMember: TeamMember) {
			if (!this.team?.id || !teamMember?.inviteCode) {
				return '';
			}
			return `${window.location.origin}/team-signup?teamName=${encodeURIComponent(this.team.name)}&teamId=${this.team.id}&inviteCode=${teamMember.inviteCode}`;
		},
	},
	components: {
		ClipboardCopy,
	},
});
